export default "__VITE_ASSET__l49Uh0a4__"